import { render, staticRenderFns } from "./StepperSection.vue?vue&type=template&id=2787870c&scoped=true"
import script from "./StepperSection.vue?vue&type=script&lang=js"
export * from "./StepperSection.vue?vue&type=script&lang=js"
import style0 from "./StepperSection.vue?vue&type=style&index=0&id=2787870c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2787870c",
  null
  
)

export default component.exports